import React from 'react';
import { View, StyleSheet } from 'react-native';
import { UnifiedModal } from '@/components/common/UnifiedModal';

interface BottomSheetModalProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  /** Whether to show close button even without title (for tooltips) */
  showCloseButton?: boolean;
  /** Off for hosts whose child owns a ScrollView/FlatList (one scroller, never two). */
  scrollable?: boolean;
}

/**
 * Bottom sheet modal that slides up from the bottom with gesture dismiss.
 * Backed by UnifiedModal with variant="sheet".
 */
export const BottomSheetModal: React.FC<BottomSheetModalProps> = ({
  visible,
  onClose,
  children,
  title,
  showCloseButton = false,
  scrollable = true,
}) => {
  const shouldShowHeader = !!title || showCloseButton;

  return (
    <UnifiedModal
      visible={visible}
      onClose={onClose}
      variant="sheet"
      showHeader={shouldShowHeader}
      title={title}
      enableGestureDismiss
      scrollable={scrollable}
      contentContainerStyle={scrollable ? styles.scrollContent : undefined}
    >
      <View style={styles.content}>{children}</View>
    </UnifiedModal>
  );
};

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 24,
    paddingBottom: 8,
  },
  // The sheet keeps its own 24/8 inset above; the modal's scroll container adds none, so 1x spacing is unchanged.
  scrollContent: {
    paddingHorizontal: 0,
    paddingBottom: 0,
  },
});
